module.exports = __webpack_public_path__ + "media/images/file-icons/512/002-tool-ca898e36f62653954a9cd03752a6b892.png";